import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { style: {"padding":"20px"} }
const _hoisted_10 = {
  key: 0,
  class: "easy-wrap"
}
const _hoisted_11 = ["src"]

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allTask, addTask,reviseTaskState,delTask} from '../../api'
  import { getToken } from '@/utils/auth'
  import {getUrl} from '../../api/comfig'

  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const  httpUrl=getUrl();

  const search = reactive({
    key: "",
    state: "0",
  })
 

  
const headers= reactive({
  'token': getToken()
})
  
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
    { title: "图片", key: "icon", align: "center" , customSlot: "thumbnail"},
    { title: "排序", key: "px", align: "center" },
    { title: "名称", key: "name", align: "center" },
    { title: "说明", key: "caption", align: "center" },
    { title: "类型", key: "type", align: "center", customSlot: "type" },
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "ios（分钟）", key: "iosDuration", align: "center" },
    { title: "web（分钟）", key: "webDuration", align: "center" },
    { title: "安卓（分钟）", key: "androidDuration", align: "center" },
    { title: "链接", key: "link", align: "center" },
    { title: "预付量", key: "limitAmount", align: "center" },
    { title: "新量", key: "newQuantity", align: "center" },
    { title: "总完成量", key: "totalAmount", align: "center" },
    { title: "备注", key: "remark", align: "center" },
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllTask = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key,"state": search.state };
    allTask(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllTask();
  
  
  const change = (page: any) => {
    getAllTask();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片

const signleImg = (imgur: any) => {
  layer.photos({
    imgList: [{ src: imgur }]
  })
}
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllTask();
  }
   
  //修改类型接口
  const changeState = (row: any) => { 
  var data = { "key": row.state, "id":row.id };
  reviseTaskState(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
        getAllTask();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
  
  //上传文件回调方法
  const getUploadFile2 = (res: any) => {
  res = JSON.parse(res.data);
  if (res.code == 0) {
    advertise.icon = res.data.src;
 
    layer.msg("上传成功", { time: 1000, icon: 1 })
  } else {
    layer.msg("上传异常", { icon: 3, time: 1000 })
  }

}
 
  
  const advertise = reactive({
    id:0,
    name: "",
    px:0,
    icon: "",
    caption: "", 
    webDuration: 0, 
    iosDuration: 0,  
    androidDuration:0, 
    link: "", 
    limitAmount: "", 
    remark: "",  
    type:"",
    multistation:[] ,
    verificationBasis:[]
  })
  
  
  const deleDelTask = (row: any) => {
       var data={'id':row.id} 
       delTask(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllTask(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  const updateAdvertise= (row: any) => {

    advertise.id = row.id;
    advertise.px = row.px;
    advertise.name =row.name;
    advertise.icon = row.icon;
    advertise.caption =row.caption;
    advertise.webDuration =row.webDuration;
    advertise.iosDuration = row.iosDuration;
    advertise.androidDuration = row.androidDuration;
    advertise.link = row.link;
    advertise.remark = row.remark;
    advertise.limitAmount = row.limitAmount;
    advertise.type = row.type; 
     if (row.multistation) {
      let uniqueArr: number[] = row.multistation.split(",").map(Number);
    advertise.multistation = uniqueArr;
     }
     
     if (row.verificationBasis) {
      let verificationBasisuniqueArr: number[] = row.verificationBasis.split(",").map(Number);
    advertise.verificationBasis = verificationBasisuniqueArr;
     }

  
    
    
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const changeVisible11 = () => {
    advertise.id = 0;
    advertise.px = 0;
    advertise.name = "";
    advertise.icon = "";
    advertise.caption = "下载“***”并安装成功可领取会员时长";
    advertise.webDuration = 0;
    advertise.iosDuration = 0;
    advertise.androidDuration = 0;
    advertise.link = "";
    advertise.limitAmount = "";
    advertise.remark = "";
    advertise.type="",
    advertise.verificationBasis=[],
    advertise.multistation=[]
  
  
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {

        if (advertise.verificationBasis.length!=0) {
      let verificationBasisuniqueArr: number[] =  [...new Set(advertise.verificationBasis)];
    advertise.verificationBasis = verificationBasisuniqueArr.join(", ")
     }else{
      advertise.verificationBasis ="";
     }

     if (advertise.multistation.length!=0) {
      let multistationuniqueArr: number[] = [...new Set(advertise.multistation)];
        advertise.multistation= multistationuniqueArr.join(", ")
     }else{
      advertise.multistation ="";
     }
       

      

        addTask(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllTask();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])
  
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_upload = _resolveComponent("lay-upload")!
  const _component_lay_checkbox = _resolveComponent("lay-checkbox")!
  const _component_lay_checkbox_group = _resolveComponent("lay-checkbox-group")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "名称",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "正常"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "下架"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 1 ? true : false,
                      onChange: ($event: any) => (changeState(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "下架"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  thumbnail: _withCtx(({ row }) => [
                    _createElementVNode("img", {
                      src: row.icon,
                      onClick: ($event: any) => (signleImg(row.icon)),
                      style: {"width":"62.9px","height":"80px"}
                    }, null, 8, _hoisted_2)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateAdvertise(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deleDelTask(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  type: _withCtx(({ row }) => [
                    (row.type==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "签到"))
                      : (row.type==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "新用户"))
                        : (row.type==3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "新用户"))
                          : (row.type==4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "app下载"))
                            : (row.type==5)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "服务器验证"))
                              : (row.type==6)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "系统赠送"))
                                : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['600px', '750px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_lay_form, {
            model: advertise,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "图片",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_upload, {
                    onDone: getUploadFile2,
                    disabledPreview: false,
                    multiple: false,
                    acceptMime: "image/*",
                    url: _unref(httpUrl)+'/common/imgUpload/advertise',
                    field: "file",
                    headers: headers
                  }, {
                    preview: _withCtx(() => [
                      (advertise.icon!='')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: advertise.icon,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (signleImg(advertise.icon))),
                              style: {"width":"80.9px","height":"80.2px"}
                            }, null, 8, _hoisted_11)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["url", "headers"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "类型",
                prop: "type",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: advertise.type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((advertise.type) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "签到"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "新用户"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 3,
                        label: "邀新"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 4,
                        label: "app下载"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 5,
                        label: "服务器验证"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 6,
                        label: "系统赠送"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "设备",
                prop: "multistation",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_checkbox_group, {
                    modelValue: advertise.multistation,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((advertise.multistation) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_checkbox, {
                        name: "multistation",
                        value: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("ios")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_lay_checkbox, {
                        name: "multistation",
                        value: 2
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("安卓")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_lay_checkbox, {
                        name: "multistation",
                        value: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("web")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "验证类型",
                prop: "verificationBasis",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_checkbox_group, {
                    modelValue: advertise.verificationBasis,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((advertise.verificationBasis) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_checkbox, {
                        name: "verificationBasis",
                        value: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("ip")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_lay_checkbox, {
                        name: "verificationBasis",
                        value: 2
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("账号")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_lay_checkbox, {
                        name: "verificationBasis",
                        value: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("设备码")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.name,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((advertise.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "说明",
                prop: "caption"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.caption,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((advertise.caption) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "排序",
                prop: "px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.px,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((advertise.px) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "ios（分钟）",
                prop: "iosDuration"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.iosDuration,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((advertise.iosDuration) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "web（分钟）",
                prop: "webDuration"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.webDuration,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((advertise.webDuration) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "安卓（分钟）",
                prop: "androidDuration"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.androidDuration,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((advertise.androidDuration) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "链接",
                prop: "link"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.link,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((advertise.link) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "预付量",
                prop: "limitAmount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.limitAmount,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((advertise.limitAmount) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.remark,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((advertise.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})